import {combineReducers}  from 'redux';
import howitwork from  './home/howitWork/reducer'
import ourvehicle from  './home/ourvehicle/reducer'
import testimonial from  './home/testimonial/reducer'
import whychooseskycar from  './home/whychooseskycar/reducer'
import FAQs from  './home/faqs/reducer'//Sarada:10-10-2022
import discountoffer from './home/homeoffers/reducer'
import aboutinfo from './home/aboutinfo/reducer'
import aboutuscontent from  './aboutus/aboutcontent/reducer'
import values from  './aboutus/values/reducer'
import aboutbanner from  './aboutus/aboutbanner/reducer'

const reducers = combineReducers({
  howitwork,
  ourvehicle,
  whychooseskycar,
  FAQs,
  discountoffer,
  aboutinfo,
  testimonial,
  aboutuscontent,
  values,
  aboutbanner
});

export default reducers;
